import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, renderSlot, createTextVNode, toDisplayString } from 'vue';

var script = defineComponent({
    name: 'Hyperlink',
    props: {
        ariaControls: { type: String, default: '' },
        button: { type: Boolean, default: false },
        colour: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        newWindow: { type: Boolean, default: false },
        onClick: { type: Function, default: undefined },
        prefix: { type: String, default: '' },
        text: { type: String, default: '' },
        url: { type: String, default: '#' },
        subtle: { type: Boolean, default: false }
    },
    setup(props) {
        const cssStyles = computed(() => {
            const baseClass = `${props.prefix}link`;
            return [
                baseClass,
                props.colour && `${baseClass}--${props.colour}`,
                props.subtle && `${baseClass}--subtle`,
                props.disabled && `${baseClass}--disabled`
            ];
        });
        return { cssStyles };
    }
});

const _hoisted_1 = ["target", "href", "role", "aria-disabled", "aria-controls", "onClick"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("a", {
    target: _ctx.newWindow ? '_blank' : null,
    href: _ctx.url,
    class: normalizeClass(_ctx.cssStyles),
    role: _ctx.button ? 'button' : null,
    "aria-disabled": _ctx.button && _ctx.disabled ? `${_ctx.disabled}` : null,
    "aria-controls": _ctx.ariaControls ? _ctx.ariaControls : null,
    onClick: _ctx.button && _ctx.disabled ? _ctx.preventClick : _ctx.onClick
  }, [
    renderSlot(_ctx.$slots, "default", {}, () => [
      createTextVNode(toDisplayString(_ctx.text), 1 /* TEXT */)
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}

script.render = render;
script.__file = "packages/vue/hyperlink/lib/Hyperlink.vue";

export { script as default };
